<template>
  <v-app-bar app :class="navClass" hide-on-scroll flat height="60">
    <!-- 手机端导航栏 -->
    <div class="d-md-none nav-mobile-container">
      <div style="font-size:18px;font-weight:bold">
        <router-link to="/" class="brand">
          <img class="brand-logo" src="/imgs/logo.png" alt="logo" />
          {{ blogInfo.webSite.author }}
        </router-link>
      </div>
      <div class="nav-mobile-actions">
        <ThemeSwitcher />
        <a @click="openDrawer" aria-label="菜单">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            <path d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </a>
      </div>
    </div>
    <!-- 电脑导航栏 -->
    <div class="d-md-block d-none nav-container">
      <div class="float-left blog-title">
        <router-link to="/" class="brand">
          <img class="brand-logo" src="/imgs/logo.png" alt="logo" />
          {{ blogInfo.webSite.author }}
        </router-link>
      </div>
      <div class="float-right nav-title">

        <div class="menus-item">
          <router-link class="menu-btn" to="/">
            <i class="iconfont iconzhuye" /> 首页
          </router-link>
        </div>
        <div class="menus-item">
          <router-link class="menu-btn" to="/nav">
            <i class="iconfont iconqita" /> 导航
          </router-link>
        </div>
        <div class="menus-item">
          <router-link class="menu-btn" to="/works">
            <i class="iconfont iconqita" /> 产品
          </router-link>
        </div>
        <div class="menus-item">
          <router-link class="menu-btn" to="/story">
            <i class="iconfont iconfaxian" /> 故事
          </router-link>
        </div>
        <div class="menus-item">
          <router-link class="menu-btn" to="/about">
            <i class="iconfont iconzhifeiji" /> 关于
          </router-link>
        </div>
        <div class="menus-item">
          <router-link class="menu-btn" to="/message">
            <i class="iconfont iconpinglunzu" /> 留言
          </router-link>
        </div>
        <div class="menus-item menus-theme">
          <ThemeSwitcher />
        </div>


        <!--<div class="menus-item">
          <a
            class="menu-btn"
            v-if="!this.$store.state.avatar"
            @click="openLogin"
          >
            <i class="iconfont icondenglu" /> 登录
          </a>
          <template v-else>
            <img
              class="user-avatar"
              :src="this.$store.state.avatar"
              height="30"
              width="30"
            />
            <ul class="menus-submenu">
              <li>
                <router-link to="/user">
                  <i class="iconfont icongerenzhongxin" /> 个人中心
                </router-link>
              </li>
              <li>
                <a @click="logout"><i class="iconfont icontuichu" /> 退出</a>
              </li>
            </ul>
          </template>
        </div>-->
      </div>
    </div>
  </v-app-bar>
</template>

<script>
import { logout } from "../../api";
import ThemeSwitcher from "../ThemeSwitcher";

export default {
  components: { ThemeSwitcher },
  mounted() {
    window.addEventListener("scroll", this.scroll);
    // 进页面先按当前位置定一次样式，否则未滚动前是 Vuetify 默认的白底栏，
    // 压在深色 banner 上看不清字
    this.scroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scroll);
  },
  data: function() {
    return {
      navClass: "nav"
    };
  },
  methods: {
    scroll() {
      const that = this;
      that.scrollTop = window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (that.scrollTop > 60) {
        that.navClass = "nav-fixed";
      } else {
        that.navClass = "nav";
      }
    },
    openSearch() {
      this.$store.state.searchFlag = true;
    },
    openDrawer() {
      this.$store.state.drawer = true;
    },
    openLogin() {
      this.$store.state.loginFlag = true;
    },
    logout() {
      //如果在个人中心则跳回上一页
      if (this.$route.path === "/user") {
        this.$router.go(-1);
      }
      logout().then(res => {
        this.$store.commit("logout");
        this.$toast({ type: "success", message: "注销成功" });
      }).catch(err =>{
        console.log(err)
      });
    }
  },
  computed: {
    avatar() {
      return this.$store.state.avatar;
    },
    blogInfo() {
      return this.$store.state.blogInfo;
    }
  }
};
</script>

<style scoped>
i {
  margin-right: 4px;
}
ul {
  list-style: none;
}
/* 站点整体是暖米白底，导航文字用深色 */
.nav {
  background: var(--nav-glass) !important;
  backdrop-filter: saturate(140%) blur(10px);
}
.nav a {
  color: var(--ink-mid) !important;
}
.nav a:hover {
  color: var(--ink) !important;
}
.theme--light.nav-fixed {
  background: var(--nav-glass) !important;
  backdrop-filter: saturate(140%) blur(10px);
  border-bottom: 1px solid var(--border-soft);
}
.theme--dark.nav-fixed {
  background: rgba(20, 20, 19, 0.9) !important;
}
.theme--dark.nav-fixed a {
  color: rgba(255, 255, 255, 0.82) !important;
}
.theme--light.nav-fixed a {
  color: var(--ink-mid) !important;
}
.theme--light.nav-fixed a:hover {
  color: var(--ink) !important;
}
.blog-title a {
  font-weight: 600;
  letter-spacing: -0.2px;
}
.brand {
  display: inline-flex;
  align-items: center;
}
.brand-logo {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 9px;
  display: block;
}
.nav-fixed .menus-item a,
.nav-fixed .blog-title a {
  text-shadow: none;
}
.nav-container {
  font-size: 14px;
  width: 100%;
  height: 100%;
}
.nav-mobile-container {
  width: 100%;
  display: flex;
  align-items: center;
}
/* iconfont 里这两个字形在移动端渲染不出来，改用 mdi 图标 */
.nav-mobile-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
}
.nav-mobile-actions a,
.nav-mobile-actions .theme-switch {
  margin-left: 16px;
  display: inline-flex;
  align-items: center;
}
.nav-mobile-actions svg {
  color: var(--ink-mid);
  display: block;
}
.blog-title,
.nav-title {
  display: flex;
  align-items: center;
  height: 100%;
}
.blog-title a {
  font-size: 18px;
  font-weight: bold;
}
.menus-item {
  position: relative;
  display: inline-block;
  margin: 0 0 0 0.875rem;
}
.menus-item a {
  transition: all 0.2s;
}
.nav-fixed .menu-btn:hover {
  color: var(--accent) !important;
}
.menu-btn:hover:after {
  width: 100%;
}
.menus-theme {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin-left: 1.1rem;
}
.menus-item a:after {
  position: absolute;
  bottom: -5px;
  left: 0;
  z-index: -1;
  width: 0;
  height: 3px;
  background-color: var(--accent-wash);
  content: "";
  transition: all 0.3s ease-in-out;
}
.user-avatar {
  cursor: pointer;
  border-radius: 50%;
}
.menus-item:hover .menus-submenu {
  display: block;
}
.menus-submenu {
  position: absolute;
  display: none;
  right: 0;
  width: max-content;
  margin-top: 8px;
  box-shadow: 0 5px 20px -4px rgba(0, 0, 0, 0.5);
  background-color: #fff;
  animation: submenu 0.3s 0.1s ease both;
}
.menus-submenu:before {
  position: absolute;
  top: -8px;
  left: 0;
  width: 100%;
  height: 20px;
  content: "";
}
.menus-submenu a {
  line-height: 2;
  color: #4c4948 !important;
  text-shadow: none;
  display: block;
  padding: 6px 14px;
}
.menus-submenu a:hover {
  background: #4ab1f4;
}
@keyframes submenu {
  0% {
    opacity: 0;
    filter: alpha(opacity=0);
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    filter: none;
    transform: translateY(0);
  }
}
</style>
